import { Card, CardContent, Chip, Divider, Grid, Typography, colors } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Page } from "components";
import ReactMarkdown from "react-markdown/with-html";
import PropTypes from "prop-types";
import React from "react";
import clsx from "clsx";


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3)
  },
  divider2: {
    marginBottom: theme.spacing(2)
  },
  card: {
    marginBottom: theme.spacing(2)
  },
  chip: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: 5
  },
  red: {
    backgroundColor: colors.red["200"],
  }
}));

const FAQs = [{
  title: "Where is the changelog?",
  content: `The full changelog for the app and the CMS can be viewed <a href="/help/changelog">here</a>.`,
  tags: ["General"]
},
{
  title: "How do I remove an account's credit card?",
  content: `An account's credit cards are listed under the account's summary page.`,
  tags: ["General"]
},
{
  title: "Why can't I add/delete masteries, modules or routines?",
  content: `This feature is currently being discussed and developed, and will be made available when ready.`,
  tags: ["General"]
},
{
  title: "Why can't teachers upload activities on the app?",
  content: `This feature is currently being discussed and developed, and will be made available when ready.`,
  tags: ["App"]
},
{
  title: "Why can't I find a student that was inside the old Xin Xiu app?",
  content: `The database for the old Xin Xiu app and the current one are separate databases. If it was there but is not found here, it's possible that the account was not provided in the list for migration. You can create a new account in the <a href="/accounts">Accounts</a> listing page.`,
  tags: ["General"]
},
{
  title: "Why isn't there any Chinese translations in the CMS?",
  content: `The CMS is not intended for non-admins. The CMS contains sensitive information, and should not be made available to people other than authorized admins of Xin Xiu Wushu.`,
  tags: ["General"]
},]


const HelpPage = props => {
  const classes = useStyles();

  let half = Math.floor(FAQs.length / 2);
  let left = FAQs.slice(0, half);
  let right = FAQs.slice(half);

  return (
    <Page className={classes.root} title="Help" >
      <Typography variant="h2">Frequently Asked Questions</Typography>
      <Divider className={classes.divider} />
      <Grid container spacing={3}>
        <Grid xl={6} lg={6} md={6} sm={12} item>
          {left.map((faq, index) => (
            <Card key={index} className={classes.card}>
              <CardContent>
                <Typography gutterBottom variant="h5">{faq.title}{faq.tags.map((tag, idx) => (<Chip key={idx} className={clsx({ [classes.chip]: true, [classes.red]: tag === "App" })} label={tag} size="small" />))}</Typography>
                <Divider className={classes.divider2} />
                <ReactMarkdown className="MuiTypography-body1" source={faq.content} escapeHtml={false} />
              </CardContent>
            </Card>
          ))}
        </Grid>
        <Grid xl={6} lg={6} md={6} sm={12} item>
          {right.map((faq, index) => (
            <Card key={index} className={classes.card}>
              <CardContent>
                <Typography gutterBottom variant="h5">{faq.title}{faq.tags.map((tag, idx) => (<Chip key={idx} className={clsx({ [classes.chip]: true, [classes.red]: tag === "App" })} label={tag} size="small" />))}</Typography>
                <Divider className={classes.divider2} />
                <ReactMarkdown className="MuiTypography-body1" source={faq.content} escapeHtml={false} />
              </CardContent>
            </Card>
          ))}
        </Grid>
      </Grid>
    </Page>
  );
};

HelpPage.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default HelpPage;
